import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { AcquirerUser } from '@root/globalTypes';

export function useGetUserByToken({
  type,
  token,
}: {
  type: 'invitations' | 'password';
  token: string;
}) {
  const { query } = useApi();

  const { data, isPending } = useQuery<AcquirerUser>({
    queryKey: [...queryKeys.acquirerUsers, token],
    queryFn: (): Promise<AcquirerUser> =>
      query({
        path: `v1/acquirer/users/${type}/${token}`,
        useAuth: false,
      }),
    enabled: Boolean(token),
  });

  return {
    data: data,
    isPending,
  };
}
